import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  align: {
    top: "5px",
    right: "-5px",
  },
}));
